<template>
  <div class="info-about-selected-carrier">
    <div class="documents-information">
      <span> {{ $t("carriers.modalInfo.selectedCarrier") }} </span>
      : <br />
      <div v-if="!insurance" class="documents-information__text">
        <p v-if="!isPickup">USD ${{ formatEasyPostPriceWithoutPickup(carrier).toFixed(2) }} </p>
        <p v-else>USD ${{ formatEasyPostPriceWithPickup(carrier, carrier.quoteContractId).toFixed(2) }} </p>
      </div>
      <div class="documents-information__text" v-else>
        <p v-if="!isPickup">
          USD ${{ (formatEasyPostPriceWithoutPickup(carrier) + aditionalInsurance).toFixed(2) }}
        </p>
        <p v-else>
          USD ${{
           ( formatEasyPostPriceWithPickup(carrier) + aditionalInsurance).toFixed(2)
          }}
        </p>
      </div>
    </div>
    <div class="disclaimer-info" v-if="carrier && carrier.chsSubtotal === 0">
       <i>
        <i class="ion ion-information-circle-outline disclaimer-icon"></i>
        {{$t('myLoads.messageNonChasis1')}} {{carrier ? carrier.chsMinRentalDays : ''}} {{nonChasisMessage}}
      </i>
    </div>
  </div>
</template>

<script>
import FormatEasyPostPrices from "../../../../../../Extend/FormatEasyPostPrices";

export default {
  name: "InfoAboutSelectedCarrier",
  mixins: [FormatEasyPostPrices],
  props: {
    insurance: Boolean,
    transportSelected: Object,
    carrier: Object,
    aditionalInsurance: Number,
    isPickup: Boolean,
    originalCarrierArray: Array
  },
  computed: {
    nonChasisMessage() {
      const isBranded = this.$store.getters["login/getTokenInfo"].is_branded;
      return isBranded ? this.$t("myLoads.messageNonChasisbranded") : this.$t("myLoads.messageNonChasis2");
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
.info-about-selected-carrier {
  span {
    font-weight: bold;
  }
  p {
    margin: 0px;
  }
}
.disclaimer-info {
  display: flex;
  text-align: left;
  align-items: flex-start;
  width: 100%;
  color: $color-primary-company;
  font-size: 0.9rem;
  padding-top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  font-weight: 400;
}
.disclaimer-icon {
  font-weight: bold;
  margin-right: 5px;
  color: $color-secondary-button-border;
}

</style>
